module.exports = "<div id=\"pageInfo\">\r\n  home works!\r\n<div>\r\n"